import React, { useState } from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, mobileHero, mobileHeroText, viewMenu } from 'images'
import ViewMenu from './ViewMenu'
import ReserveButton from './ReserveButton'

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="105VH"
          w="100%"
          image={`url(${mobileHero}) center / cover no-repeat`}
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
          column
          justifyBetween
          alignCenter
        >
          <CFView
            column
            center
            style={{
              background:
                'linear-gradient(to bottom,  rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0) 100% 0%)',
            }}
          >
            <CFImage src={mobileHeroText} w="80%" alt="Promotions" mt="15px" />
          </CFView>
          <CFView bg="rgba(0,0,0,.8)" pt="15px" w="100%" textCenter>
            <CFView pulsate>
              <OrderPickupButton />
            </CFView>
            <CFView h4 xBold hover onClick={() => setShowModal(true)}>
              <CFImage
                w="230px"
                src={viewMenu}
                alt="Sushi Wara Logo"
                zIndex={98}
              />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="95vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) top/ cover no-repeat`}
          zIndex={90}
          column
          justifyBetween
          alignCenter
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
        >
          <Header />
          <CFView
            row
            center
            alignCenter
            w="100%"
            maxWidth="800px"
            bg="rgba(0,0,0,.8)"
            pt="5px"
          >
            <CFView column justifyStart mr="20px">
              <CFText hero raleway white xBold style={{ fontSize: 30 }}>
                NOW TAKING ONLINE ORDERS
              </CFText>
            </CFView>
            <CFView pulsate mt="2px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
      <ViewMenu
        showModal={showModal}
        onRequestClose={() => setShowModal(false)}
      />
    </CFView>
  )
}
